module.exports = __webpack_public_path__ + "media/images/digivent/logo_nomiri-60509b99a30bd7866c4d32e0cbab56d5.svg";